// 渠道管理模块

//获取渠道信息
function getTunnelInformation(userid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", pagename: "bgetpiplink", userid },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok") {
              resolve(jsonRes.msg);
            } else {
              resolve(false);
            }
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//返回渠道路径
function getTunnelPath(pipid, codeid, sencname, userinfid, userid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", pagename: "bsetpipcode", idxpath: "pages/index/index", pipid, codeid, sencname, userinfid, userid },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取渠道二维码
function getTunnelCode(querystr = "") {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", pagename: "bgetpipcode", userid: Cookies.get("userid-b"), querystr },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//删除渠道二维码
function deleteTunnelCode(codeid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", pagename: "bdelpipcode", userid: Cookies.get("userid-b"), codeid },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

export default {
  getTunnelInformation,
  getTunnelPath,
  getTunnelCode,
  deleteTunnelCode
};
